import { Text } from '@/ui-kit'
import { clsx } from 'clsx'
import { Fragment } from 'react/jsx-runtime'
import { ReferralsListProps } from './ReferralsList'

export const ReferralsMobileList = ({ columns, referrals }: ReferralsListProps) => {
  return (
    <ul className="mt-4 space-y-2">
      {referrals.map((referral) => (
        <li
          key={referral.email}
          className={clsx(
            'relative flex cursor-pointer flex-col gap-1 rounded-2xl border-[1px] border-solid p-4 transition'
          )}
        >
          <Text className="mb-1">{referral.email || '-'}</Text>
          {columns.map((column) => (
            <Fragment key={`${referral.email}_${column.name}`}>
              <div className="flex">
                <Text className="text-gray-90 w-[120px]" type="body3-regular">
                  {column.name}
                </Text>
                <Text type="body3-regular">{column.value(referral)}</Text>
              </div>
            </Fragment>
          ))}
        </li>
      ))}
    </ul>
  )
}
